var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUpToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.617 5.38298 24 12 24C18.617 24 24 18.617 24 12C24 5.38298 18.617 0 12 0C5.38298 0 0 5.38298 0 12ZM12.707 8.29298L17.707 13.293C17.902 13.488 18 13.744 18 14C18 14.256 17.902 14.512 17.707 14.707C17.316 15.098 16.684 15.098 16.293 14.707L12 10.414L7.707 14.707C7.31602 15.098 6.684 15.098 6.29302 14.707C5.90203 14.316 5.90203 13.684 6.29302 13.293L11.293 8.29298C11.684 7.902 12.316 7.902 12.707 8.29298Z",
    fill: "#141B3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpToggle);
export default __webpack_public_path__ + "static/media/IconArrowUpToggle.445c2cb6c1622d1d0cb07941bfb2a2bd.svg";
export { ForwardRef as ReactComponent };